import { ReportName } from './types';

export const REPORTS = ['regularHealthCheckupReportPdf', 'healthCheckupInstitutionPdf'] as const;

export const REPORT_MAP: { [key in ReportName]: string } = {
  regularHealthCheckupReportPdf: '定期健康診断結果報告書',
  healthCheckupInstitutionPdf: '様式6別紙　健康診断実施機関'
};
